import { render } from "./ProjectAutocomplete.vue?vue&type=template&id=3fd08964&scoped=true"
import script from "./ProjectAutocomplete.vue?vue&type=script&lang=js"
export * from "./ProjectAutocomplete.vue?vue&type=script&lang=js"

import "./ProjectAutocomplete.vue?vue&type=style&index=0&id=3fd08964&scoped=true&lang=css"

import exportComponent from "/var/www/hrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fd08964"]])

export default __exports__